
import {
  defineComponent,
  onMounted,
  ref,
  useRouter,
  watch,
} from '@nuxtjs/composition-api';
import useShopsCenter from '~/composables/useShopsCenter';
import useScrollToTop from '~/composables/useScrollToTop';
import ShopList from '~/domains/where-to-buy/components/ShopList';
import CountriesModal from '~/domains/where-to-buy/components/CountriesModal';
import WhereToBuyCaption from '~/domains/where-to-buy/components/WhereToBuyCaption';
import EmptyShopList from '~/domains/where-to-buy/components/EmptyShopList';

export default defineComponent({
  name: 'WhereToBuyMainSection',
  components: { EmptyShopList, WhereToBuyCaption, CountriesModal, ShopList },
  props: {
    country: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    const modal = ref(null);
    const router = useRouter();
    const {
      countries,
      currentCountry,
      currentPage,
      shops,
      totalPagesCount,
      isLoadingShops,
      isLoading,
      isNoShopsInCurrentCountry,
      resetShops,
      fetchCountries,
      fetchShops,
      checkUserCountry,
    } = useShopsCenter();

    const handleChangeCountry = (country) => {
      modal.value.$children[0].close();
      resetShops();
      currentCountry.value = country;
    };

    watch(currentCountry, (newValue, oldValue) => {
      if (!oldValue || newValue.id === oldValue.id) return;
      router.push({
        query: {
          page: 1,
        },
      });
      isNoShopsInCurrentCountry.value = false;
      useScrollToTop();
      fetchShops();
    });

    watch(currentPage, () => {
      useScrollToTop();
      fetchShops();
    });

    onMounted(async () => {
      await fetchCountries();
      await checkUserCountry();
      await fetchShops();
    });

    return {
      countries,
      isLoading,
      isLoadingShops,
      shops,
      currentPage,
      totalPagesCount,
      modal,
      currentCountry,
      isNoShopsInCurrentCountry,
      handleChangeCountry,
    };
  },
});
